import React from 'react';
import { Tabs, Tab, Box } from '@mui/material';

const PathTabs = ({ paths, activePathId, onPathChange }) => {
  if (!paths || paths.length <= 1) return null;

  const handleChange = (event, newValue) => {
    onPathChange(newValue);
  };

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
      <Tabs
        value={activePathId}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          '& .MuiTab-root': {
            textTransform: 'none',
            fontWeight: 500,
            fontSize: '0.9rem',
            minHeight: 42,
          }
        }}
      >
        {paths.map(path => (
          <Tab
            key={path.id}
            label={path.name}
            value={path.id}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default PathTabs;
